import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    showMenu:false
  },
  mutations: {
    UPDATE_SHOWMENU: (state)=>{
      state.showMenu = !state.showMenu;
    }
  },
  actions: {
    togleMenu: (context)=>{
      context.commit('UPDATE_SHOWMENU')
    }
  }
})
